var map = {
	"./en/SDG-01-EN-INVERTED.png": "4694",
	"./en/SDG-01-EN.png": "1bb3",
	"./en/SDG-02-EN-INVERTED.png": "6aec",
	"./en/SDG-02-EN.png": "b169",
	"./en/SDG-03-EN-INVERTED.png": "9a7e",
	"./en/SDG-03-EN.png": "8f52",
	"./en/SDG-04-EN-INVERTED.png": "3c74",
	"./en/SDG-04-EN.png": "d87f",
	"./en/SDG-05-EN-INVERTED.png": "1d54",
	"./en/SDG-05-EN.png": "02ec",
	"./en/SDG-06-EN-INVERTED.png": "e802",
	"./en/SDG-06-EN.png": "1f87",
	"./en/SDG-07-EN-INVERTED.png": "e2e8",
	"./en/SDG-07-EN.png": "3926",
	"./en/SDG-08-EN-INVERTED.png": "5b26",
	"./en/SDG-08-EN.png": "8c02b",
	"./en/SDG-09-EN-INVERTED.png": "9064",
	"./en/SDG-09-EN.png": "75c6",
	"./en/SDG-10-EN-INVERTED.png": "4f23",
	"./en/SDG-10-EN.png": "ab93",
	"./en/SDG-11-EN-INVERTED.png": "7d03",
	"./en/SDG-11-EN.png": "0c8e",
	"./en/SDG-12-EN-INVERTED.png": "273e",
	"./en/SDG-12-EN.png": "8dd5",
	"./en/SDG-13-EN-INVERTED.png": "ca2d",
	"./en/SDG-13-EN.png": "c96d",
	"./en/SDG-14-EN-INVERTED.png": "da18",
	"./en/SDG-14-EN.png": "ad42",
	"./en/SDG-15-EN-INVERTED.png": "2f11",
	"./en/SDG-15-EN.png": "d646",
	"./en/SDG-16-EN-INVERTED.png": "683d",
	"./en/SDG-16-EN.png": "9739",
	"./en/SDG-17-EN-INVERTED.png": "8e88",
	"./en/SDG-17-EN.png": "4fe9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc42";